<template>
    <v-dialog :value="true" max-width="520" :fullscreen="$vuetify.breakpoint.xsOnly" persistent scrollable>
        <v-card>
            <v-card-title class="d-block">
                <div class="text-h6">Liberar outra conta</div>
                <div class="body-2 grey--text text--darken-1">
                    {{ item.fantasia || `Empresa ${item.empresa_id}` }} · {{ cenario(item.cenario).texto }}
                </div>
            </v-card-title>
            <v-divider/>

            <v-card-text class="pt-4">
                <v-card outlined class="pa-3 mb-3">
                    <div class="text-overline grey--text text--darken-1 conta-rotulo">Conta que recebe os pagamentos hoje</div>
                    <template v-if="item.titular">
                        <div class="subtitle-1 font-weight-bold">{{ item.titular.nome || '—' }}</div>
                        <div class="body-2 grey--text text--darken-2">{{ contaTexto(item.titular) }}</div>
                    </template>
                    <div v-else class="body-2">Sem conta de referência: a chave de acesso não respondeu ao Mercado Pago.</div>
                </v-card>

                <v-card v-if="item.tentativa" outlined class="pa-3 mb-4 tentativa">
                    <div class="text-overline conta-rotulo tentativa-rotulo">Última tentativa bloqueada</div>
                    <div class="subtitle-1 font-weight-bold">{{ (item.tentativa.conta && item.tentativa.conta.nome) || 'conta sem titular' }}</div>
                    <div class="body-2 grey--text text--darken-2">{{ contaTexto(item.tentativa.conta) }}</div>
                    <div class="caption grey--text text--darken-1">
                        {{ formatDate(item.tentativa.em, 'DD/MM/YYYY [às] HH:mm') }}<span v-if="item.tentativa.usuario"> · usuário {{ item.tentativa.usuario }}</span>
                    </div>
                </v-card>

                <v-textarea
                    v-model="motivo"
                    label="Motivo (obrigatório)"
                    placeholder="Ex.: conta do sócio [nome], confirmada com o responsável por WhatsApp em [data]"
                    outlined
                    rows="3"
                    counter="255"
                    maxlength="255"
                    hide-details="auto"
                />

                <v-checkbox
                    v-model="confirmou"
                    label="Confirmei a troca com o responsável da empresa."
                    hide-details
                    class="mt-2"
                />

                <v-alert dense text type="info" class="mt-4 mb-0 body-2">
                    A próxima conexão aceita qualquer conta Mercado Pago. Ao conectar, os administradores da empresa
                    recebem o e-mail de troca de conta.
                </v-alert>
            </v-card-text>

            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn text @click="$emit('close')">Cancelar</v-btn>
                <v-btn color="primary" :disabled="!podeLiberar" :loading="enviando" @click="liberar">Liberar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { cenario, contaTexto } from './situacoes';

export default {
    name: 'LiberarOutraContaDialog',

    props: {
        item: { type: Object, required: true },
    },

    data: () => ({
        motivo: '',
        confirmou: false,
        enviando: false,
    }),

    computed: {
        podeLiberar() {
            return this.confirmou && this.motivo.trim().length >= 10;
        },
    },

    methods: {
        cenario,
        contaTexto,

        async liberar() {
            this.enviando = true;

            try {
                const { data } = await this.$http.post(`mercadopago-migracao/${this.item.empresa_id}/liberar-outra-conta`, {
                    motivo: this.motivo.trim(),
                });

                this.notify(data.msg, data.type === 'success' ? 'success' : 'warning');
                data.type === 'success' && this.$emit('liberou');
            } catch (e) {
                this.notify('Verifique sua conexão com a internet', 'warning');
            } finally {
                this.enviando = false;
            }
        },
    },
};
</script>

<style scoped>
.conta-rotulo {
    line-height: 1.6;
}

.tentativa {
    background: #fff7ee;
    border-color: #f2d3b0 !important;
}

.tentativa-rotulo {
    color: #8a4508;
}
</style>
